import ROLES from '@/utils/roles';
import PROCESS from '@/utils/process';
import TOP_BARS from '@/utils/topBars';
import FOOTERS from '@/utils/footers';
import Manages from './stuManage';
import Cards from './card';
import LOGIN_STATE from '../../components/login/loginState';
import Plat from 'utils/plat';
let routes = [
  {
    path: '/student/checkin',
    name: 'student-checkin',
    meta: {
      title: '现场报到准备'
    },
    component: () => import('views/student/Hsylc2025/Checkin')
  },
  /**
   * @description HSYLC Student Orientation
   * @function /hsylc-guide-course HSYLC Student Orientation
   * @param { Component } GuideCourse /views/student/Hsylc2025/GuideCourse/index.vue
   * @param { Name } pathname GuideCourse
   */
  {
    path: '/hsylc-guide-course',
    name: 'hsylc-guide-course',
    meta: {
      title: 'HSYLC Student Orientation'
    },
    component: () => import('@/views/student/Hsylc2025/GuideCourse/index.vue')
  },
  /**
   * @description 峰会结束过渡页面
   * @function /student/session-end 峰会结束过渡页面
   * @param { Component } SessionEnd /views/HsylcFinish//SessionEnd/index.vue
   * @param { Name } pathname SessionEnd
   */
  {
    path: '/student/session-end',
    name: 'student-session-end',
    meta: {
      title: 'HSYLC 2022'
    },
    component: () => import('@/views/HsylcFinish/SessionEnd/index.vue')
  },
  /**
   * @description 证书信息页面
   * @function /student/session-end 证书信息页面
   * @param { Component } SessionEnd /views/student/Hsylc2023/Certs/index.vue
   * @param { Name } pathname SessionEnd
   */
  {
    path: '/student/certificate/2023',
    name: 'student-certificate-2023',
    meta: {
      title: 'HSYLC 证书'
    },
    component: () => import('@/views/student/Hsylc2023/Certs/index.vue')
  },
  /**
   * @description 证书信息页面
   * @function /student/certificate 证书信息页面
   * @param { Component } Certs /views/student/Hsylc2026/Certs/index.vue
   * @param { Name } pathname student-certificate
   */
  {
    path: '/student/certificate',
    name: 'student-certificate',
    meta: {
      title: 'HSYLC 证书'
    },
    component: () => import('@/views/student/Hsylc2026/Certs/index.vue')
  },
  /**
   * @description 完善信息页
   * @function /info 完善信息页
   * @param { Component } Info views/login/Info.vue
   * @param { Name } pathname info
   */
  {
    path: '/info',
    name: 'info',
    meta: {
      title: '完善信息页',
      topBar: TOP_BARS.NULL
    },
    props: {
      initState: LOGIN_STATE.COMPLETE_INFO
    },
    component: () => import('@/views/login')
  },
  /**
   * @description 学生申请
   * @function /student-apply/:name? 学生申请
   * @param { Component } Application views/application/Application.vue
   * @param { Name } pathname student-apply
   */
  {
    path: '/student/apply',
    name: 'student-apply',
    meta: {
      title: '学生申请'
      // process: PROCESS.STU_APPLY
    },
    component: () => import('@/views/student/Apply')
  },
  /**
   * @description 学生申请
   * @function /hsylc/apply 学生申请
   * @param { Component } Application views/application/Application.vue
   * @param { Name } pathname student-apply
   */
  {
    path: '/hsylc/apply',
    name: 'hsylc-apply',
    meta: {
      title: '学生申请'
      // process: PROCESS.STU_APPLY
    },
    component: () => import('@/views/student/Apply')
  },
  /**
   * @description 个人成长展示
   * @function /student/additional-info 个人成长展示
   * @param { Component } student2 views/student/application/student2.vue
   * @param { Name } pathname student-apply2
   */
  {
    path: '/student/additional-info',
    name: 'student-apply2',
    meta: {
      title: '个人成长展示'
      // process: PROCESS.STU_APPLY
    },
    component: () => import('@/views/student/Apply')
  },
  /**
   * @description 支付申请
   * @function /student/apply/pay 支付申请
   * @param { Component } Pay views/student/Pay
   * @param { Name } pathname student-pay
   */
  {
    path: '/pay/apply',
    name: 'student-pay',
    meta: {
      title: '支付申请'
      // process: PROCESS.STU_APPLY
    },
    component: () => import('@/views/student/Apply')
  },
  /**
   * @description 名校早知道
   * @function /student/elite-schools-know
   * @param { Component } EliteSchoolsKnow views/student/EliteSchoolsKnow
   * @param { Name } pathname elite-schools-know
   */
  {
    path: '/student/elite-schools-know',
    name: 'student-elite-schools-know',
    meta: {
      title: '名校早知道'
    },
    component: () => import('@/views/student/EliteSchoolsKnow')
  },
  /**
   * @description 账户信息
   * @function /account 账户信息
   * @param { Component } Account views/student/Account
   * @param { Name } pathname account
   */
  {
    path: '/account',
    name: 'account',
    meta: {
      title: '账户信息'
    },
    component: () => import('@/views/student/Account')
  },
  /**
   * @description 账户信息
   * @function /account 账户信息
   * @param { Component } Account views/student/Account
   * @param { Name } pathname account-edit
   */
  {
    path: '/account/edit',
    name: 'account-edit',
    meta: {
      title: '完善信息页'
    },
    props: {
      initState: LOGIN_STATE.COMPLETE_INFO
    },
    component: () => import('@/views/student/Account/Edit')
  },
  /**
   * @description 申请助学金
   * @function /student/apply/pay 申请助学金
   * @param { Component } Pay /apply/financial-aid
   * @param { Name } pathname insturctions-tuituin
   */
  {
    path: '/apply/financial-aid',
    name: 'insturctions-tuituin',
    disabled: Plat.isAMCSite,
    meta: {
      title: '申请助学金'
    },
    component: () => import('@/views/student/applyTuituin')
  },
  /**
   * @description 成功申请助学金
   * @function /apply/financial-aid/success 成功申请助学金
   * @param { Component } success views/student/applyTuituin/success
   * @param { Name } pathname insturctions-tuituin-success
   */
  {
    path: '/apply/financial-aid/success',
    name: 'insturctions-tuituin-success',
    disabled: Plat.isAMCSite,
    meta: {
      title: '成功申请助学金'
    },
    component: () => import('@/views/student/applyTuituin/success.vue')
  },
  /**
   * @description 邮箱验证成功
   * @function /email/validate-success 邮箱验证成功
   * @param { Component } success views/student/EmailValidateStatus/success
   * @param { Name } pathname email-validate-success
   */
  {
    path: '/email/validate-success',
    name: 'email-validate-success',
    meta: {
      title: '邮箱验证成功'
    },
    component: () => import('@/views/student/EmailValidateStatus/success.vue')
  },
  /**
   * @description 邮箱验证失败
   * @function /email/validate-fail 邮箱验证失败
   * @param { Component } fail views/student/EmailValidateStatus/fail
   * @param { Name } pathname email-validate-fail
   */
  {
    path: '/email/validate-fail',
    name: 'email-validate-fail',
    meta: {
      title: '邮箱验证失败'
    },
    component: () => import('@/views/student/EmailValidateStatus/fail.vue')
  },
  /**
   * @description 学生录取信息页面
   * @function /student/admission 学生录取信息页面
   * @param { Component } Admission views/student/Admission
   * @param { Name } pathname stu-admission
   */
  {
    path: '/student/admission/:tab?',
    name: 'stu-admission',
    meta: {
      title: '录取信息页面'
    },
    component: () => import('@/views/student/Admission')
  },
  /**
   * @description 学生录取信息页面
   * @function /student/admission 学生录取信息页面
   * @param { Component } Admission views/student/Admission
   * @param { Name } pathname stu-admission
   */
  {
    path: '/student/fha-introduction',
    name: 'stu-fha-introduction',
    meta: {
      title: 'FHA介绍'
    },
    component: () => import('@/views/student/FHAIntro')
  },
  /**
   * @description 小课程内页
   * @function /student/hsylc101 小课程内页
   * @param { Component } hsylc101 views/student/hsylc2023
   * @param { Name } pathname student-hsylc101
   */
  {
    path: '/student/hsylc101',
    name: 'student-hsylc101',
    meta: {
      title: 'HSYLC 101'
    },
    component: () => import('@/views/student/Hsylc2023/Hsylc101')
  },
  /**
   * @description 小课程内页
   * @function /student/small-class/:className 小课程内页
   * @param { Component } SmallClass views/student/SmallClass
   * @param { Name } pathname stu-admission
   */
  {
    path: '/student/small-class/:className',
    name: 'stu-small-class',
    meta: {
      title: '哈佛原版小课程'
    },
    component: () => import('@/views/student/SmallClass')
  },
  /**
   * @description 幸福学课程内页
   * @function /student/admission-positive 幸福学课程内页
   * @param { Component } Positive views/student/Admission/Positive
   * @param { Name } pathname stu-admission
   */
  {
    path: '/student/admission-positive',
    name: 'stu-admission-positive',
    meta: {
      title: '幸福学课程'
    },
    component: () => import('@/views/student/SmallClass'),
    props: {
      className: 'positive'
    }
  },
  /**
   * @description 学生主修课方向
   * @function /student/admission/todolist/major 学生主修课方向
   * @param { Component } major views/student/Admission/toDoList/major
   * @param { Name } pathname pay-admission-todolist-major
   */
  {
    path: '/student/admission/todolist/major',
    name: 'pay-admission-todolist-major',
    meta: {
      title: '主修课方向'
    },
    component: () => import('@/views/student/Admission/toDoList/major')
  },
  /**
   * @description 收听8期Ivy Podcast
   * @function /student/admission/todolist/lvyPodcast 收听8期Ivy Podcast
   * @param { Component } lvyPodcast views/student/Admission/toDoList/lvyPodcast
   * @param { Name } pathname pay-admission-lvyPodcast
   */
  {
    path: '/student/admission/todolist/lvyPodcast',
    name: 'pay-admission-lvyPodcast',
    meta: {
      title: '收听8期Ivy Podcast'
    },
    component: () => import('@/views/student/Admission/toDoList/lvyPodcast')
  },
  /**
   * @description Lvy Podcast 内页
   * @function /pay/admission/todolist/lvyPodcast-content Lvy Podcast 内页
   * @param { Component } content views/student/Admission/toDoList/lvyPodcast/content
   * @param { Name } pathname pay-admission-lvyPodcast-content
   */
  {
    path: '/pay/admission/todolist/lvyPodcast-content',
    name: 'pay-admission-lvyPodcast-content',
    meta: {
      title: '收听8期Ivy Podcast'
    },
    component: () => import('@/views/student/Admission/toDoList/lvyPodcast/content')
  },
  /**
   * @description 2020年大师课Master Class 精彩回顾
   * @function /pay/admission/todolist/masterClass 2020年大师课Master Class 精彩回顾
   * @param { Component } masterClass views/student/Admission/toDoList/masterClass
   * @param { Name } pathname pay-admission-masterClass
   */
  {
    path: '/pay/admission/todolist/masterClass',
    name: 'pay-admission-masterClass',
    meta: {
      title: '2020年大师课Master Class 精彩回顾'
    },
    component: () => import('@/views/student/Admission/toDoList/masterClass')
  },
  /**
   * @description 录取支付页面
   * @function /pay/admission 录取支付页面
   * @param { Component } Admission views/student/Pay/Admission
   * @param { Name } pathname pay-admission
   */
  {
    path: '/pay/admission',
    name: 'pay-admission',
    meta: {
      title: '录取支付页面'
    },
    component: () => import('@/views/student/Pay/Admission')
  },
  /**
   * @description HSYLC 峰会前先导学习
   * @function /pay/admission/pilot-study HSYLC 峰会前先导学习
   * @param { Component } PilotStudy views/student/Pay/Admission/PilotStudy
   * @param { Name } pathname pay-admission-pilot-study
   */
  {
    path: '/pay/admission/pilot-study',
    name: 'pay-admission-pilot-study',
    meta: {
      title: 'HSYLC 峰会前先导学习'
    },
    component: () => import('@/views/student/Pay/Admission/PilotStudy')
  },
  /**
   * @description 转线上通知内页 - 需要登录
   * @function /notice/online-notice 录取支付成功页面
   * @param { Component } OnlineNotice views/Notice/OnlineNotice
   * @param { Name } pathname notice-online-notice
   */
  {
    path: '/notice/online-notice',
    name: 'notice-online-notice',
    meta: {
      title: '关于2022HSYLC峰会举办形式正式通知'
    },
    component: () => import('@/views/Notice/OnlineNotice')
  },
  /**
   * @description 十二学院抢地盘
   * @function /xii-siege 十二学院抢地盘
   * @param { Component } GrabFlag views/student/GrabFlag
   * @param { Name } pathname xii-siege
   */
  {
    path: '/xii-siege',
    name: 'xii-siege',
    meta: {
      name: 'hsylc 2021'
    },
    component: () => import('@/views/student/GrabFlag')
  },
  {
    path: '/scene-form',
    component: () => import('@/views/student/SceneForms'),
    children: [
      /**
       * @description 基本信息补充
       * @function /scene-form 基本信息补充
       * @param { Component } Basic views/student/SceneForms/Basic
       * @param { Name } pathname scene-form
       */
      {
        path: '',
        name: 'scene-form',
        meta: {
          title: '基本信息补充'
        },
        component: () => import('@/views/student/SceneForms/Basic')
      },
      /**
       * @description 基本信息补充
       * @function /scene-form/basic 基本信息补充
       * @param { Component } Basic views/student/SceneForms/Basic
       * @param { Name } pathname scene-form-basic
       */
      {
        path: 'basic',
        name: 'scene-form-basic',
        meta: {
          title: '基本信息补充'
        },
        component: () => import('@/views/student/SceneForms/Basic')
      },
      /**
       * @description 基本健康信息
       * @function /scene-form/health 基本健康信息
       * @param { Component } Health views/student/SceneForms/Health
       * @param { Name } pathname scene-form-health
       */
      {
        path: 'health',
        name: 'scene-form-health',
        meta: {
          title: '基本健康信息'
        },
        component: () => import('@/views/student/SceneForms/Health')
      },
      /**
       * @description 峰会包裹
       * @function /scene-form/address 峰会包裹
       * @param { Component } Address views/student/SceneForms/Address
       * @param { Name } pathname scene-form-address
       */
      {
        path: 'address',
        name: 'scene-form-address',
        meta: {
          title: '峰会包裹'
        },
        component: () => import('@/views/student/SceneForms/Address')
      }
    ]
  },
  /**
   * @description 分院测试游戏页面
   * @function /sorting-ceremony 分院测试游戏页面
   * @param { Component } Test views/student/SortingCeremony/Test
   * @param { Name } pathname sorting-ceremony
   */
  {
    path: '/sorting-ceremony',
    name: 'sorting-ceremony',
    meta: {
      title: 'HSYLC 2022 分院测试',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/Activities/Digital')
  },

  /**
   * @description 往届信息展示
   * @function /student/previous/info
   * @param {Component} PreviousInfo /views/student/PreviousInfo
   * @param {Name} pathname student-previous-info
   */
  {
    path: '/student/previous/info',
    name: 'student-previous-info',
    meta: {
      title: '学生'
    },
    component: () => import('@/views/student/PreviousInfo')
  },
  /**
   * @description 学生端 往届信息 路由名称需要找时间更改
   * @function /student/manage
   * @param {Component} Manager /views/student/Manager
   * @param {Name} pathname student-manage
   */
  {
    path: '/student/manage',
    name: 'student-manage',
    meta: {
      title: '学生'
    },
    component: () => import('@/views/student/PreviousInfo')
  },
  /**
   * @descrition Talent Show 落地页
   * @function /student/talent-show
   * @param { Component } TalentShow /views/student/TalentShow
   * @param { name } pathname student-talent-show
   */
  {
    path: '/student/talent-show',
    name: 'student-talent-show',
    meta: {
      title: 'Talent Show海选规则'
    },
    component: () => import('../../views/student/TalentShow')
  },
  /**
   * @descrition 学生house-reveal
   * @function /student/house-reveal-begin
   * @param { Component } CourseDetail views/student/Manager/House/HouseReveal/Begin
   * @param { name } pathname student-house-reveal-begin
   */
  {
    path: '/student/house-reveal-begin',
    name: 'student-house-reveal-begin',
    meta: {
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/student/Manager/House/HouseReveal/Begin/index.vue')
  },
  /**
   * @descrition 学生house-reveal
   * @function /student/house-reveal-result
   * @param { Component } CourseDetail views/student/Manager/House/HouseReveal/Result
   * @param { name } pathname student-house-reveal-result
   */
  {
    path: '/student/house-reveal-result',
    name: 'student-house-reveal-result',
    meta: {
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/student/Manager/House/HouseReveal/Result/index.vue')
  },
  {
    path: '/student/aww/detail',
    name: 'student-aww-detail',
    meta: {
      title: 'Academic Writing Workshop',
      topBar: TOP_BARS.TEXT_BLOCK
    },
    component: () => import('@/views/student/Manager/AWWDetail')
  },
  /**
   * @descrition 学院奇葩说
   * @function /debate
   * @param { Component } Debate views/student/Manager/Events/Debate
   * @param { name } pathname debate
   */
  {
    path: '/debate',
    name: 'debate',
    meta: {
      title: '学院奇葩说'
    },
    component: () => import('../../views/student/Manager/Events/Debate')
  },
  {
    path: '/memory',
    name: 'memory',
    meta: {
      title: '我和我的峰会',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/student/MemoryWXTest')
  },
  {
    path: '/memoryWX',
    name: 'memoryWX',
    meta: {
      title: '我和我的峰会',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/student/MemoryWXTest')
  },
  {
    path: '/csi/apply',
    name: 'csi-apply',
    component: () => import('../../views/student/CSI/Apply')
  },
  /**
   * @descrition 峰会后学生重要信息采集
   * @function /student/information
   * @param { Component } Information views/student/Information
   * @param { name } pathname student-information
   */
  {
    path: '/student/information',
    name: 'student-information',
    component: () => import('../../views/student/Information')
  },
  // /**
  //  * @descrition 峰会后学生重要信息采集
  //  * @function /student/information
  //  * @param { Component } Information views/student/Information
  //  * @param { name } pathname student-information
  //  */
  {
    path: '/student/base-health-info',
    name: 'student-base-health-info',
    component: () => import('../../views/student/BaseHealthInfo')
  },
  /**
   * @description 北京会场住宿安排
   * @function /accommodation
   * @param { name } accommodation
   */
  {
    path: '/accommodation',
    name: 'accommodation',
    component: () => import('../../views/student/Accommodation')
  },
  /**
   * @description 收集报到时间及押金
   * @function /student/checkin-deposit
   * @param { name } pathname student-checkin-deposit
   */
  {
    path: '/student/checkin-deposit',
    name: 'student-checkin-deposit',
    meta: { title: '收集报到时间及押金' },
    component: () => import('../../views/student/CheckinDeposit')
  },
  /**
   * @description 2026 分院问卷
   * @function /student/house/survey
   * @param { name } pathname student-house-survey
   */
  {
    path: '/student/house/survey',
    name: 'student-house-survey',
    component: () => import('../../views/student/HouseSurvey')
  },
  /**
   * @description 2026 Primer 自测题
   * @function /student/primer/self-test
   * @param { name } pathname student-primer-self-test
   */
  {
    path: '/student/primer/self-test',
    name: 'student-primer-self-test',
    component: () => import('../../views/student/Primer/Quiz')
  },
  /**
   * @description 2026 加入官方群并添加会场老师
   * @function /student/place/wecom
   * @param { name } pathname student-place-wecom
   */
  {
    path: '/student/place/wecom',
    name: 'student-place-wecom',
    component: () => import('../../views/student/PlaceWeCom')
  },
  /**
   * @descrition 峰会后学生重要信息采集
   * @function /student/information
   * @param { Component } Information views/student/Information
   * @param { name } pathname student-information
   */
  {
    path: '/student/college-info-session',
    name: 'student-college-info-session',
    component: () => import('../../views/student/Hsylc2023/CollegeInfoSession')
  },
  {
    path: '/student/admission-letter',
    name: 'student-admission-letter',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/student/Admission/Paid/View/Welcome/AdmissionLetter')
  },
  ...Cards,
  ...Manages
].filter(item => !item.disabled);
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    role: ROLES.STUDENT
  });
  return ret;
});
export default routes;
